import React from 'react';
import { useNavigate } from "react-router-dom";
import { ActionIcon, useMantineColorScheme, Text, MediaQuery, useMantineTheme, Menu, Group, Box, Drawer, Divider } from '@mantine/core';
import { IconSun, IconMoonStars, IconUser, IconAlignLeft } from '@tabler/icons-react';

import { useLoginContext } from "../context/loginContext";
import { useNavBarStateContext } from "../context/navBarStateContext";

import { safetyDecodeJWT, getPropInSubLevelJWT, getPropInSubLevelRole } from "../utils/globalFunctions";
import { usersCanAccessNotification } from "../utils/accessing";

import ModalTakeAction from "../components/general/ModalTakeAction";
import BrandComponent from "./BrandComponent";
import MenuList from "./MenuList";
import PencarianCepatModal from "./PencarianCepatModal";
import Notifications from "./Notifications";

const Toggler = () => {

    const theme = useMantineTheme();
    const { colorScheme, toggleColorScheme } = useMantineColorScheme();
    const light = colorScheme === 'light';

    return (
        <React.Fragment>
            <ActionIcon
                variant='subtle'
                radius='xl'
                size='lg'
                sx={{
                    border: 0,
                    color: theme.colorScheme === 'light' ? theme.colors.gray[9] : theme.colors.gray[2]
                }}
                onClick={() => toggleColorScheme()}
                title={light ? 'Mode Gelap' : 'Mode Terang'}
            >
                {light ?
                    <IconMoonStars
                        size={20}
                        strokeWidth={1.5}
                    />
                    :
                    <IconSun
                        size={24}
                        strokeWidth={1.5}
                    />}
            </ActionIcon>
        </React.Fragment>
    )
}

const HeaderNav = ({ stateMenuList, stateMenu, stateSubMenu = '' }) => {

    const theme = useMantineTheme();
    const navigate = useNavigate();
    const { loginContext, handleSetLoginContext } = useLoginContext();
    const { navBarState, handleSetNavBarStateContext } = useNavBarStateContext();

    const [drawer, setDrawer] = React.useState(false);
    const [data, setData] = React.useState({
        modalSignOut: false
    })

    const getSubMenuTitle = () => {
        try {
            let res = '';
            const keysMenu = Object.keys(stateMenuList);

            keysMenu.forEach((keyMenu, indexMenu) => {
                if (stateMenuList[keyMenu].slug === stateMenu) {

                    const keysSubMenu = Object.keys(stateMenuList[keyMenu].subMenu);

                    keysSubMenu.forEach((keySubMenu, indexSubMenu) => {
                        if (stateMenuList[keyMenu].subMenu[keySubMenu].flag === stateSubMenu) {
                            res = stateMenuList[keyMenu].subMenu[keySubMenu].name;
                            return false;
                        }
                    })
                }
            })

            return res;
        } catch (error) {
            return '';
        }
    }

    return (
        <React.Fragment>
            <Group
                className='headerNavComponent'
                position='apart'
                noWrap={true}
                spacing='xs'

                py='md'
                px='sm'
            >
                <Group noWrap={true}>
                    {/* MOBILE */}
                    <MediaQuery largerThan="md" styles={{ display: 'none' }}>
                        <ActionIcon
                            variant='subtle'
                            radius='xl'
                            size='lg'
                            sx={{
                                border: 0,
                                color: theme.colorScheme === 'light' ? theme.colors.gray[9] : theme.colors.gray[2]
                            }}
                            title={'Menu'}
                            onClick={() => setDrawer(true)}
                        >
                            <IconAlignLeft
                                size={22}
                                strokeWidth={1.5}
                            />
                        </ActionIcon>
                    </MediaQuery>

                    {/* DESKTOP */}
                    <MediaQuery smallerThan="md" styles={{ display: 'none' }}>
                        <ActionIcon
                            variant='subtle'
                            radius='xl'
                            size='lg'
                            sx={{
                                border: 0,
                                color: theme.colorScheme === 'light' ? theme.colors.gray[9] : theme.colors.gray[2]
                            }}
                            title={'Menu'}
                            onClick={() => handleSetNavBarStateContext(!navBarState)}
                        >
                            <IconAlignLeft
                                size={22}
                                strokeWidth={1.5}
                            />
                        </ActionIcon>
                    </MediaQuery>

                    <Text lineClamp={1} tt='uppercase' sx={{ fontWeight: '500', fontSize: theme.fontSizes.lg }}>
                        {getSubMenuTitle()}
                    </Text>
                </Group>

                <Group spacing='sm' noWrap={true}>
                    <PencarianCepatModal />

                    {usersCanAccessNotification({ stateObject: { subLevel: loginContext } }) &&
                        <Notifications />
                    }

                    <Toggler />

                    <Menu
                        shadow="md"
                        width={250}
                    >
                        <Menu.Target>
                            <ActionIcon
                                variant='subtle'
                                radius='xl'
                                size='lg'
                                sx={{
                                    border: 0,
                                    color: theme.colorScheme === 'light' ? theme.colors.gray[9] : theme.colors.gray[2]
                                }}
                                title={'Settings'}
                            >
                                <IconUser
                                    size={22}
                                    strokeWidth={1.5}
                                />
                            </ActionIcon>
                        </Menu.Target>

                        <Menu.Dropdown>
                            <Menu.Label>
                                <Text
                                    sx={(tema) => ({
                                        color: tema.colorScheme === 'light' ? tema.colors.dark[9] : tema.colors.dark[0]
                                    })}
                                >
                                    <Text
                                        size='sm'
                                    >
                                        {safetyDecodeJWT(loginContext, 'syswebapp', 'syswebappn')}
                                    </Text>

                                    <Text>
                                        {getPropInSubLevelJWT(loginContext, 'caption', '')}
                                    </Text>

                                    <Divider my='md' />

                                    <Text
                                        size='sm'
                                        tt='uppercase'

                                        sx={(tema) => ({
                                            display: 'inline',
                                            cursor: 'pointer',
                                            color: tema.colorScheme === 'light' ? tema.colors.blue[4] : tema.colors.blue[4],

                                            '&:hover': {
                                                color: tema.colorScheme === 'light' ? tema.colors.blue[6] : tema.colors.blue[3],
                                            }
                                        })}

                                        onClick={() => {
                                            navigate(`/${getPropInSubLevelRole(safetyDecodeJWT(loginContext, 'syswebapp', 'syswebappsl'), 'slugLink', '')}/${stateMenuList.account.slug}/${stateMenuList.account.subMenu.one.flag}/${stateMenuList.account.subMenu.one.tabs.one.flag}`, { replace: true });
                                        }}
                                    >
                                        Account Setting
                                    </Text>

                                    <Divider my='md' />

                                    <Text
                                        size='sm'
                                        tt='uppercase'

                                        sx={(tema) => ({
                                            display: 'inline',
                                            cursor: 'pointer',
                                            color: tema.colorScheme === 'light' ? tema.colors.blue[4] : tema.colors.blue[4],

                                            '&:hover': {
                                                color: tema.colorScheme === 'light' ? tema.colors.blue[6] : tema.colors.blue[3],
                                            }
                                        })}

                                        onClick={() => setData(d => ({ ...d, modalSignOut: true }))}
                                    >
                                        Sign Out
                                    </Text>
                                </Text>
                            </Menu.Label>
                        </Menu.Dropdown>
                    </Menu>
                </Group>
            </Group>

            <ModalTakeAction
                stateShow={data.modalSignOut}
                fnHide={() => setData(d => ({ ...d, modalSignOut: false }))}
                stateTitle='Confirmation'
                stateButtonActionCaption='Sign Out'
                fnButtonAction={() => handleSetLoginContext(null)}
                stateButtonActionLoading={false}
            >
                Sign Out ?
            </ModalTakeAction>

            <Drawer
                opened={drawer}
                onClose={() => setDrawer(false)}
                title={<BrandComponent />}
                size='xs'
                withCloseButton={false}

                sx={() => ({
                    '& .mantine-Paper-root.mantine-Drawer-content::-webkit-scrollbar': {
                        width: '8px',
                        height: '8px',
                    },

                    '& .mantine-Paper-root.mantine-Drawer-content::-webkit-scrollbar-track': {
                        backgroundColor: 'transparent'
                    },

                    '& .mantine-Paper-root.mantine-Drawer-content::-webkit-scrollbar-thumb': {
                        backgroundColor: theme.colorScheme === 'light' ? theme.colors.gray[4] : theme.colors.dark[4],
                        borderRadius: '4px'
                    },

                    '& .mantine-Paper-root.mantine-Drawer-content::-webkit-scrollbar-thumb:hover': {
                        backgroundColor: theme.colorScheme === 'light' ? theme.colors.gray[5] : theme.colors.dark[3],
                    },
                })}
            >
                <Box mt='md'>
                    <MenuList
                        stateMenuList={stateMenuList}
                        stateMenu={stateMenu}
                        fnClickMenu={() => setDrawer(false)}
                    />
                </Box>
            </Drawer>
        </React.Fragment>
    )
}

export default HeaderNav;